import combineBatches from './combine-batches';
import createBatch from './create-batch';
import convertPlainBatchToBreakpointBasedBatch from './convert-plain-batch-to-breakpoint-based-batch';
import enrichBatchToBreakpointBasedBatch from './enrich-batch-to-breakpoint-based-batch';
import generateAdjustedEventTraits from './generate-adjusted-event-traits';
import generateInitialState from './generate-initial-state';
import getBatchValues from './get-batch-values';
import getResolvedStateWithAutoFill from './get-resolved-state-with-auto-fill';
import getTargetElementIds from './get-target-element-ids';
import getStateDifference from './get-state-difference';
import getStateDifferencePerBreakpoint from './get-state-difference-per-breakpoint';
import modifyBatchChanges from './modify-batch-changes';
import { wrapSharedDataWithId, getSharedDataById } from './shared-data-utils';
import * as stageContracts from './stage-contracts';

export default {
  combineBatches,
  createBatch,
  convertPlainBatchToBreakpointBasedBatch,
  enrichBatchToBreakpointBasedBatch,
  generateAdjustedEventTraits,
  generateInitialState,
  getBatchValues,
  getResolvedStateWithAutoFill,
  getTargetElementIds,
  getStateDifference,
  getStateDifferencePerBreakpoint,
  modifyBatchChanges,
  wrapSharedDataWithId,
  getSharedDataById,
  stageContracts,
};
